"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAutocompleteResults = parseAutocompleteResults;
exports.populateAutocompleteResultsIndex = populateAutocompleteResultsIndex;
exports.getTrimmedSearchTerm = getTrimmedSearchTerm;
exports.getFilterOptionValue = getFilterOptionValue;
exports.getSidebarFiltersFromOptionValue = getSidebarFiltersFromOptionValue;
exports.getNameAndSidebarFilterOptions = getNameAndSidebarFilterOptions;
exports.isSidebarFilterType = isSidebarFilterType;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _underscore = require("underscore");

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = _interopRequireDefault(require("immutable"));

var _params = require("hub-http/helpers/params");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _GoodSubTypes = _interopRequireDefault(require("../constants/GoodSubTypes"));

var _SearchOptions = _interopRequireDefault(require("../constants/SearchOptions"));

var _langUtils = require("./langUtils");

var _utils = require("../utils/utils");

var _FILTER_TYPE_TEXT_LOO;

var FILTER_OPTION_PREFIX = '__FILTER__:';
var MINIMUM_CHARACTERS_FOR_SIDEBAR_OPTION = 3;
var FILTER_TYPE_TEXT_LOOKUP = (_FILTER_TYPE_TEXT_LOO = {}, (0, _defineProperty2.default)(_FILTER_TYPE_TEXT_LOO, _GoodFiltersAndPage.default.MODULE_PURPOSE, _langUtils.getCustomModulePurposeOptionText), (0, _defineProperty2.default)(_FILTER_TYPE_TEXT_LOO, _GoodFiltersAndPage.default.SUB_TYPE, _langUtils.getGoodSubtypeText), (0, _defineProperty2.default)(_FILTER_TYPE_TEXT_LOO, _GoodFiltersAndPage.default.TEMPLATE_PURPOSE, _langUtils.getTemplatePurposeOptionText), _FILTER_TYPE_TEXT_LOO);

function parseAutocompleteResults(results) {
  return results.map(function (result) {
    return {
      text: result.name,
      value: result.urlToken,
      help: (0, _langUtils.getGoodSubtypeText)(result.subType),
      subType: result.subType
    };
  });
}

function populateAutocompleteResultsIndex(results) {
  var resultsIndex = {};
  results.forEach(function (result) {
    resultsIndex[result.urlToken] = true;
  });
  return resultsIndex;
}

function getTrimmedSearchTerm(searchTerm) {
  return searchTerm ? searchTerm.trim() : '';
}

function getFilterOptionValue(filters) {
  return "" + FILTER_OPTION_PREFIX + (0, _params.stringify)(filters);
}

function addProviderOption(sanitizedSearchTerm, providerNames, subType, nameAndSidebarFilterOptions) {
  var _getFilterOptionValue;

  if (sanitizedSearchTerm.length < MINIMUM_CHARACTERS_FOR_SIDEBAR_OPTION) {
    return nameAndSidebarFilterOptions;
  }

  var provider = providerNames.find(function (name) {
    return name.toLowerCase().indexOf(sanitizedSearchTerm) !== -1;
  });

  if (!provider) {
    return nameAndSidebarFilterOptions;
  }

  if (sanitizedSearchTerm.length === 3 && provider.toLowerCase().indexOf('hub') === 0) {
    provider = 'HubSpot';
  }

  return nameAndSidebarFilterOptions.push({
    dropdownText: _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "header.autocomplete.providedBy",
      options: {
        providerName: provider
      }
    }),
    value: getFilterOptionValue((_getFilterOptionValue = {}, (0, _defineProperty2.default)(_getFilterOptionValue, _GoodFiltersAndPage.default.PROVIDER, provider), (0, _defineProperty2.default)(_getFilterOptionValue, _GoodFiltersAndPage.default.SUB_TYPE, subType || _GoodSubTypes.default.ALL), _getFilterOptionValue))
  });
}

function getSidebarFiltersFromOptionValue(filterOptionValue) {
  var parsedFilters = (0, _params.parse)(filterOptionValue.replace(FILTER_OPTION_PREFIX, ''));
  var modulePurpose = parsedFilters[_GoodFiltersAndPage.default.MODULE_PURPOSE];

  if (modulePurpose) {
    parsedFilters[_GoodFiltersAndPage.default.MODULE_PURPOSE] = _immutable.default.List([modulePurpose]);
  }

  return parsedFilters;
}

function getTextForFilterOption(filterType, option) {
  return FILTER_TYPE_TEXT_LOOKUP[filterType](option);
}

function getSidebarFilterMatch(filterType, searchTerm) {
  return _SearchOptions.default[filterType].find(function (option) {
    return getTextForFilterOption(filterType, option).toLowerCase().indexOf(searchTerm) !== -1;
  });
}

function addFilterMatchToResults(filterType, searchTerm, nameAndSidebarFilterOptions) {
  var sidebarFilterOption = getSidebarFilterMatch(filterType, searchTerm);

  if (!sidebarFilterOption) {
    return nameAndSidebarFilterOptions;
  }

  return nameAndSidebarFilterOptions.push({
    dropdownText: _react.default.createElement("span", null, _I18n.default.text('header.autocomplete.filteredBy'), ' ', _react.default.createElement("strong", null, getTextForFilterOption(filterType, sidebarFilterOption))),
    value: getFilterOptionValue((0, _defineProperty2.default)({}, filterType, sidebarFilterOption))
  });
}

function addSubTypeOption(sanitizedSearchTerm, nameAndSidebarFilterOptions) {
  if (sanitizedSearchTerm.length < MINIMUM_CHARACTERS_FOR_SIDEBAR_OPTION) {
    return nameAndSidebarFilterOptions;
  }

  return addFilterMatchToResults(_GoodFiltersAndPage.default.SUB_TYPE, sanitizedSearchTerm, nameAndSidebarFilterOptions);
}

function addFilterByNameOption(sanitizedSearchTerm, goodFilters, numAutocompleteGoodResults, nameAndSidebarFilterOptions) {
  if (numAutocompleteGoodResults <= 1 || !sanitizedSearchTerm) {
    return nameAndSidebarFilterOptions;
  }

  var leadingText = _I18n.default.text('header.autocomplete.catchAllWithSearchTerm');

  if (!(0, _utils.areAllSidebarFiltersAtInitialValue)(goodFilters)) {
    leadingText = _I18n.default.text('header.autocomplete.catchFilteredWithSearchTerm');
  }

  return nameAndSidebarFilterOptions.push({
    dropdownText: _react.default.createElement("span", null, leadingText, " ", _react.default.createElement("strong", null, sanitizedSearchTerm)),
    value: sanitizedSearchTerm
  });
}

function addCustomModulePurposeOption(sanitizedSearchTerm, subType, nameAndSidebarFilterOptions) {
  if (subType !== _GoodSubTypes.default.CUSTOM_MODULE || sanitizedSearchTerm.length < MINIMUM_CHARACTERS_FOR_SIDEBAR_OPTION) {
    return nameAndSidebarFilterOptions;
  }

  return addFilterMatchToResults(_GoodFiltersAndPage.default.MODULE_PURPOSE, sanitizedSearchTerm, nameAndSidebarFilterOptions);
}

function addTemplatePurposeOption(sanitizedSearchTerm, subType, nameAndSidebarFilterOptions) {
  if (subType === _GoodSubTypes.default.ALL || subType === _GoodSubTypes.default.PACKS || subType === _GoodSubTypes.default.CUSTOM_MODULE || sanitizedSearchTerm.length < MINIMUM_CHARACTERS_FOR_SIDEBAR_OPTION) {
    return nameAndSidebarFilterOptions;
  }

  return addFilterMatchToResults(_GoodFiltersAndPage.default.TEMPLATE_PURPOSE, sanitizedSearchTerm, nameAndSidebarFilterOptions);
}

function getNameAndSidebarFilterOptions(searchTerm, goodFilters, allProviders, numAutocompleteGoodResults) {
  var sanitizedSearchTerm = getTrimmedSearchTerm(searchTerm).toLowerCase();
  var subType = goodFilters.get(_GoodFiltersAndPage.default.SUB_TYPE);
  return (0, _underscore.compose)(addCustomModulePurposeOption.bind(null, sanitizedSearchTerm, subType), addTemplatePurposeOption.bind(null, sanitizedSearchTerm, subType), addSubTypeOption.bind(null, sanitizedSearchTerm), addProviderOption.bind(null, sanitizedSearchTerm, allProviders, subType), addFilterByNameOption.bind(null, sanitizedSearchTerm, goodFilters, numAutocompleteGoodResults))(_immutable.default.List.of());
}

function isSidebarFilterType(selectedValue) {
  return selectedValue.startsWith(FILTER_OPTION_PREFIX);
}